const customDatePickerStyle = () => ({
	cell: {
		width: '28px',
		margin: 'auto',
		padding: '8px 0 6px',
	},
	formControl: {
		paddingTop: 0,
	},
});

export default customDatePickerStyle;
